export default {
  roles: [],
  role: {}
};